<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="pos pos-kitchen" id="pos-kitchen">
        <Header @change="fetchData" />
        <a-tabs default-active-key="1" @change="fetchData">
          <a-tab-pane key="1" :tab="$t('kdu.tableView')">
            <div class="pos-kitchen-body">
              <div class="pos-task-row">
                <div class="pos-task" v-for="table in getTableOrder" :key="table.table_id">
                  <TableTaskInfo :table="table" />
                  <TableTaskBody :table="table" />
                </div>
              </div>
            </div>
          </a-tab-pane>
          <a-tab-pane key="2" :tab="$t('kdu.dishView')" @change="fetchData">
            <div class="ts-container ts-mx-auto ts-p-4">
              <div class="ts-grid ts-gride-cols-1 lg:ts-grid-cols-3 ts-gap-4">
                <div class="ts-border-2 ts-p-2 ts-rounded-md ts-border-gray-100 ts-w-full" 
                  v-for="product in getUniqProduct"
                  :key="product.product_id"
                >
                  <DishTaskInfo :product="product" />
                </div>
              </div>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import PageOptions from '@/config/PageOptions.vue'
import Header from './components/header'
import TableTaskInfo from './components/table-task-info.vue'
import TableTaskBody from './components/table-task-body.vue'
import DishTaskInfo from './components/dish-task-info.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'kduIndex',
  components: {
    Header,
    TableTaskInfo,
		TableTaskBody,
		DishTaskInfo
  },
  data() {
    return {
      loading: false
    }
  },
  created() {
    PageOptions.pageEmpty = true
    PageOptions.pageFullHeight = true
    this.fetchData()
  },
  computed: {
    ...mapGetters('restaurantSale/kdu', ['getTableOrder', 'getUniqProduct']),
  },
  methods: {
    ...mapActions('restaurantSale/kdu', ['fetch']),
    fetchData(){
      this.loading = true
      this.fetch({
          pro_group_id: localStorage.getItem('group_id')
      })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  beforeRouteLeave(to, from, next) {
    PageOptions.pageEmpty = false
    PageOptions.pageFullHeight = false
    next()
  }
}
</script>